// Curated template squad, split into a legal starting XI and a bench.
//
// team-rating treats the first 11 players it receives (slots 1-11) as the
// starting XI and the last 4 (slots 12-15) as the bench, so the submission
// order matters. The XI is a fixed 3-4-3 (1 GK, 3 DEF, 4 MID, 3 FWD) matching
// the pitch layout in player-row.tsx, and the bench is the backup GK + 1 DEF +
// 1 MID + 1 DEF. Captain is chosen at submission time
// (highest-predicted-points starter), not here.
//
// Positions and prices verified against league.players (season 2026); the
// full squad totals exactly £100.0m on 2026/27 prices.

// Starting XI — 3-4-3.
export const TEMPLATE_STARTING_XI_OPTA_IDS = [
  '3wwi5vf2l1qbz7e5zdjoy8yga', // Verbruggen (GK)
  '95pzsjfh0wf6isp6qpf9lddyh', // Senesi (DEF)
  '7e7w34imugzsufvytjxytupd5', // Lacroix (DEF)
  '9ipux4xiejibplsbbhqz8d5gp', // Guéhi (DEF)
  '2eayhzdix8knmn810sbngsdt5', // Rogers (MID)
  '3f2e9orrwiljklmmzwh2m7uvo', // Kroupi Jr (MID)
  'avh60ensgiwz1qalvn1bbqkfd', // Szoboszlai (MID)
  '6jgocc12bori2wygyu07c082x', // Rice (MID)
  'atzboo800gv7gic2rgvgo0kq1', // Haaland (FWD)
  'eaqqezw2ed1u0tt3zc128mr1m', // João Pedro (FWD)
  '9jrya38msibxt1c7rx1et4acq' // Igor Thiago (FWD)
];

// Bench — backup GK + 1 DEF + 1 MID + 1 DEF.
export const TEMPLATE_BENCH_OPTA_IDS = [
  '7w4l5mrrrg66wvdd8ndb5zb9x', // Dubravka (GK)
  '8qys6qtdwgsycxducl062zld5', // Konsa (DEF)
  'dbebh5mvzowjrp7h4qvzxvaol', // Hughes (MID)
  'chn2v9j6dqmuz2haoiuulbd91' // Diop (DEF)
];

// Full squad in submission order: starting XI first, then bench.
export const TEMPLATE_PLAYER_OPTA_IDS = [
  ...TEMPLATE_STARTING_XI_OPTA_IDS,
  ...TEMPLATE_BENCH_OPTA_IDS
];

// The pool the GYTR transfer step draws from for the blurred faces on the IN
// side of its locked transfer cards (FFH-2409). Three are picked at random per
// visit, minus whoever is being transferred out, so the cards vary between
// sessions.
//
// These are decoys. The solver's actual recommendation is the product and is
// never sent to the client, so nothing here needs to correspond to a real
// suggestion — it only needs to look like one behind the blur. Opta ids, not
// UUIDs, because UUIDs are re-minted every season.
//
// It aliases the template squad today for the obvious reason that those ids are
// already here and already known-good. It is free to diverge: replace the
// spread with its own list whenever a different set of faces reads better.
export const BLURRED_TRANSFER_PLAYERS = [...TEMPLATE_PLAYER_OPTA_IDS];

// Shown when the template cannot be loaded, or when any of the ids above no
// longer resolve against the current season's player data.
export const TEMPLATE_LOAD_ERROR_MESSAGE =
  'We could not load the template team right now. Please pick your players manually.';
